import { Component, OnInit, Output, Inject, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { CategoryService } from 'src/app/shared/services/category.service';
import { AppSettings } from '../../../app.constant';

import { User } from '../../../shared/interface/user';
import { Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/table';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';

export interface DialogData {
  status: string;
}

@Component({
  selector: 'category-table',
  templateUrl: './category-table.component.html',
  styleUrls: ['./category-table.component.css']
})

export class CategoryTableComponent implements OnInit {
  status: string;
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;

  displayedColumns: string[] = ['CategoryName', 'Edit'];
  post: any;
  httpResponseMessage: any;
  public resultdata: any;
  dataSource;
  Category: any;
  errorMessage: any;
  public buttonTitle: any;
  message: any;
  progressBar: boolean = true;
  messageText: any;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _categoryservice: CategoryService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog) { }

  ngOnInit() {
    this._categoryservice.refreshNeeded$
      .subscribe(() => {
        this.getallcategory();
      })
    this.getallcategory();
  }

  getallcategory() {
    this._categoryservice.getAllCategory(AppSettings.API_ENDPOINT + AppSettings.GetAllCategory)
      .subscribe(result => {
        this.resultdata = result;
        this.changeDetectorRefs.detectChanges();
        this.progressBar = false;
        if (!result) {
          return;
        }

        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  onEditCategory(param: any): void {
    var o = { PK_CategoryID: param.PK_CategoryID }
    this.post = JSON.stringify(o);
    this._categoryservice.getCategoryByID(AppSettings.API_ENDPOINT + AppSettings.GetCategoryByID, this.post).subscribe(
      data => {
        this.Category = data;
        this.buttonTitle = 'Update';
        this.messageEvent.emit(this.Category);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteCategory(param: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      title: "Category",
      data: param.CategoryName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        console.log(this.status);
        var o = { PK_CategoryID: param.PK_CategoryID }
        this.post = JSON.stringify(o);
        this._categoryservice.deleteCategoryByID(AppSettings.API_ENDPOINT + AppSettings.DeleteCategory, this.post).subscribe(
          data => {
            this.httpResponseMessage = data;
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}

